export default "__VITE_ASSET__CJoikPYa__"